<template>
<div id="contents">

  <div id="works" class="page_contents">
    <div class="page_header">
      <h1 class="page_header_title">
        <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
        <span>制作実績</span>
      </h1><!-- .top_sec_title -->

      <worksPageNav/>

    </div><!-- .page_header -->

    <div id="works_contents">
      <div id="works_event_index" v-if="event_list">

        <div id="works_event_index_list">
          <ul class="event_list">

            <li v-for="event_item in event_list" :key="event_item.post_id" v-bind:class="{ 'new' : event_item.is_new }">
              <p class="event_list_img"><router-link v-bind:to="{name: 'event_show', params: {id: event_item.post_id }}" class="hover"><img :src="event_item.kv_image" width="272" alt="番組のロゴ" /></router-link></p>
              <div class="event_list_info">
                <h2><router-link v-bind:to="{name: 'event_show', params: {id: event_item.post_id}}">{{ event_item.title }}</router-link></h2>
              </div><!-- .event_list_info -->
            </li>

          </ul>
        </div><!-- #works_event_index_list -->

      </div><!-- #works_event_index -->
    </div><!-- #works_contents -->

  </div><!-- #works -->

</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'event_index',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/event/index.php',
      event_list: null,
      error: null
    }
  },
  components: {
    worksPageNav
  },
  methods: {
    fetch_event_list(){
      this.$axios
        .get(this.api_url,{
          params: {
            term_id: this.select_category
          }
        })
        .then(response => {
          this.event_list = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    }
  },
  mounted () {
    this.fetch_event_list()
  }
}
</script>




















<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/event_index.vue